import React from 'react';
import GeneralInformation from './GeneralInformation';
import SubHeader from '../SubHeader';
import ListOfModels from './ListOfModels';
import NotesSection from './Notes';
import ReportDocumentation from './ReportDocumentation';

export default class Report extends React.Component {
  render() {
    const {
      report, user,
      handleInputChange, handleYearSelect, handleSelectFromList, handleRemoveFromList,
      handleFileSelect, handleFileRemove, handleInspectionDateChange, getDetailsLink
    } = this.props;

    return (
      <React.Fragment>
        <SubHeader label='Inspection Report' number='1' />
        <GeneralInformation
          user={user}
          errors={report.errors}
          status={report.status}
          description={report.description}
          inspectionDate={report.inspectionDate}
          approvalDate={report.approvalDate}
          year={report.year}
          yearList={report.yearList}
          address={report.address}
          manufacturerAddressesWithCurrent={report.manufacturerAddressesWithCurrent}
          handleInputChange={handleInputChange}
          handleInspectionDateChange={handleInspectionDateChange}
          handleYearSelect={handleYearSelect}
        />
        <ListOfModels
          models={report.models}
          getDetailsLink={getDetailsLink}
          modelList={report.modelList}
          status={report.status}
          errors={report.errors}
          handleSelectFromList={handleSelectFromList}
          handleRemoveFromList={handleRemoveFromList}
        />
        <NotesSection notes={report.notes} user={user} handleInputChange={handleInputChange} />
        <ReportDocumentation
          documents={report.documents}
          user={user}
          id={report.id}
          errors={report.errors}
          status={report.status}
          inspectionModelYear={report.year}
          handleFileSelect={handleFileSelect}
          handleFileRemove={handleFileRemove}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Edit/Report/index.jsx